/* AfterFade signup popup (22 Oct 2026, replaces Alia). Markup and copy: snippets/af-popup.liquid.
   Backend: row-rates api/popup-claim.js (codes, Klaviyo) and api/popup-event.js (funnel counts).

   Order of business on every page:
   1. Group. A first visit is assigned for 90 days: holdout (never sees the popup) or exposed, and
      within exposed variant A or B. The group also goes on the cart as the attribute af_popup_group,
      so every order says which group it came from and the holdout can answer "does the 10 % create
      orders, or only discount them".
   2. Should it show? Not to the holdout, not after a claim, not to someone who came in from one of
      our emails (Klaviyo already knows them), not within 7 days of being closed.
   3. When. After the delay AND a scroll, or exit intent on desktop, whichever first; never within
      15 s of another overlay (language toast, cart drawer, video, Alia during the side-by-side
      rollout), so two things never fight for the same visitor.
   No dependencies; nothing runs until the browser is idle after load. */
(function () {
  'use strict';
  var root = document.getElementById('af-popup');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var D = root.dataset;
  // Liquid's t filter HTML-escapes ("You&#39;re in"), so anything read back as text is decoded once
  var decoder = document.createElement('textarea');
  function dec(s) { decoder.innerHTML = String(s == null ? '' : s); return decoder.value; }
  var S = {};
  try { S = JSON.parse(document.getElementById('af-popup-strings').textContent); } catch (e) {}
  Object.keys(S).forEach(function (k) { S[k] = dec(S[k]); });
  var pill = document.getElementById('af-popup-pill');
  var dialog = root.querySelector('.afp__dialog');
  var now = Date.now();
  var DAY = 864e5;
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var forced = /[?&]afpopup=1\b/.test(location.search);

  // ---- storage. Every read and write survives a browser that refuses storage (private mode, Safari ITP).
  function cookie(name, value, days) {
    if (value === undefined) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + Math.round(days * 86400) + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  var store = {};
  try { store = JSON.parse(localStorage.getItem('afp') || '{}') || {}; } catch (e) {}
  function save() { try { localStorage.setItem('afp', JSON.stringify(store)); } catch (e) {} }

  // ?afpopup=1 is the review link: it starts from a clean visitor every time, claimed or not
  if (forced) { store = {}; save(); cookie('af_pc', '', 0); }

  // ---- 0. the configuration: the command centre's Popup page (shop metafield afterfade.popup_config),
  // or, when that was never saved, the theme settings as two arms A and B
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('af-popup-config').textContent) || {}; } catch (e) {}
  var GAMES = ['scratch', 'cards', 'gift', 'boxes', 'wheel', 'plinko', 'quiz', 'yesno', 'pumpkins'];
  var VIDEO_M = 'https://cdn.shopify.com/videos/c/vp/7f7eab587e414413aa1f83a554eb66bc/7f7eab587e414413aa1f83a554eb66bc.HD-720p-1.6Mbps-89231661.mp4';
  var VIDEO_D = 'https://cdn.shopify.com/videos/c/vp/0f855478bf974eeaaa43b215dd3f4c63/0f855478bf974eeaaa43b215dd3f4c63.SD-480p-1.5Mbps-89100156.mp4';
  var POSTER_M = 'https://cdn.shopify.com/s/files/1/1077/1860/7173/files/preview_images/7f7eab587e414413aa1f83a554eb66bc.thumbnail.0000000000.jpg';
  var POSTER_D = 'https://cdn.shopify.com/s/files/1/1077/1860/7173/files/preview_images/0f855478bf974eeaaa43b215dd3f4c63.thumbnail.0000000000.jpg';
  function num(v, lo, hi, dflt) { var n = Number(v); return isFinite(n) && v !== '' && v != null ? Math.max(lo, Math.min(hi, n)) : dflt; }
  // An arm can carry dates (the Halloween one runs 29 Oct to 1 Nov): outside them it is off, and its
  // visitors move to a live arm the way a paused arm's do. Dates are whole days, both ends included.
  function inWindow(a) {
    var t = Date.now();
    if (a.start && t < new Date(a.start + 'T00:00:00').getTime()) return false;
    if (a.end && t >= new Date(a.end + 'T00:00:00').getTime() + DAY) return false;
    return true;
  }
  var ALL = (Array.isArray(CFG.arms) ? CFG.arms : []).filter(function (a) { return a && /^[A-H]$/.test(a.id); });
  // Targeting (24 Oct, owner: "a series of differences throughout the day, to different countries on different
  // devices"): an arm can be limited to devices, markets and Brussels hours. Outside them it is off for this
  // page view, and a visitor in it moves to an arm that does apply, the way a paused arm's visitors do.
  var BXL_HOUR = (function () {
    try { return Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', hour: 'numeric', hourCycle: 'h23' }).format(new Date())); }
    catch (e) { return new Date().getHours(); }
  })();
  function targets(a) {
    var devs = Array.isArray(a.devices) ? a.devices : [];
    if (devs.length && devs.indexOf(mobile ? 'mobile' : 'desktop') < 0) return false;
    var mk = Array.isArray(a.markets) ? a.markets : [];
    if (mk.length && mk.indexOf(D.market) < 0) return false;
    var h = Array.isArray(a.hours) && a.hours.length === 2 ? a.hours.map(Number) : null;
    // [from, to): 8-20 is daytime, 20-8 runs through midnight
    if (h && h[0] !== h[1] && !(h[0] < h[1] ? BXL_HOUR >= h[0] && BXL_HOUR < h[1] : BXL_HOUR >= h[0] || BXL_HOUR < h[1])) return false;
    return true;
  }
  var ARMS = ALL.filter(function (a) { return num(a.weight, 0, 100, 0) > 0 && inWindow(a) && targets(a); });
  // Saved arms, none of which applies to this visitor right now (their device, market or hour): no popup on
  // this page. The visitor keeps their group and is still counted. Never fall back to the theme settings
  // then: those are only for a shop that never saved the Popup page.
  var noArm = ALL.length > 0 && !ARMS.length;
  if (noArm) ARMS = ALL.filter(function (a) { return num(a.weight, 0, 100, 0) > 0; }).concat(ALL).slice(0, 8);
  if (!ARMS.length) {
    var splitB = num(D.splitB, 0, 100, 0);
    // the theme's own video only when someone picked one; its old default (garage-buff) the owner turned down on 23 Oct
    var themeVideo = /55787a7f87284ecaa8035fcbff4e965b/.test(D.video || '') ? '' : D.video;
    ARMS = [{ id: 'A', weight: 100 - splitB, game: D.gameA, media: D.mediaA, delay: D.delayA, phone: D.phoneA === 'true', video_m: themeVideo, video_d: themeVideo }];
    if (splitB > 0) ARMS.push({ id: 'B', weight: splitB, game: D.gameB, media: D.mediaB, delay: D.delayB, phone: D.phoneB === 'true', video_m: themeVideo, video_d: themeVideo });
    if (!ARMS[0].weight) ARMS.shift();
  }
  var holdout = num(CFG.holdout != null ? CFG.holdout : D.holdout, 0, 50, 0) / 100;
  if (CFG.layout) root.dataset.layout = CFG.layout;
  var exitIntent = CFG.exit_intent != null ? !!CFG.exit_intent : String(D.exit) === 'true';
  function armById(id) { for (var i = 0; i < ARMS.length; i++) if (ARMS[i].id === id) return ARMS[i]; return null; }
  function weighted() {
    var total = ARMS.reduce(function (t, a) { return t + num(a.weight, 0, 100, 0); }, 0), r = rand() * total;
    for (var i = 0; i < ARMS.length; i++) { r -= num(ARMS[i].weight, 0, 100, 0); if (r < 0) return ARMS[i].id; }
    return ARMS[ARMS.length - 1].id;
  }

  // ---- 1. group
  function rand() {
    try { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] / 4294967296; } catch (e) { return Math.random(); }
  }
  var RE_GRP = /^(holdout|exposed\.[A-H])$/;
  // ---- a campaign link (23 Oct, the Halloween email): ?afopen=halloween opens the Halloween arm for anyone,
  // email subscribers and the holdout included, but only inside that arm's own dates. These visitors are a
  // group of their own ("email"), on the events and on the cart, so they never blur the site test. The
  // campaign is remembered for the rest of the visit, so the next page does not put them back in their group.
  var CAMPAIGN = { halloween: function (a) { return a.theme === 'halloween'; } };
  var qOpen = (location.search.match(/[?&]afopen=(\w+)/) || [])[1];
  var campArm = null, campOpen = false;
  if (!forced) {
    if (qOpen && CAMPAIGN[qOpen]) { store.camp = qOpen; save(); campOpen = true; }
    if (store.camp && CAMPAIGN[store.camp]) ALL.forEach(function (a) { if (!campArm && CAMPAIGN[store.camp](a) && inWindow(a)) campArm = a; });
    if (!campArm) { campOpen = false; if (store.camp) { delete store.camp; save(); } }
  }
  var grp = cookie('af_pg');
  var fresh = false;
  // Safari keeps a cookie written by script for 7 days at most (24 h after an ad click), so a holdout
  // visitor would be re-rolled into exposed and dilute the comparison. The cart attribute is held by
  // Shopify's own cart cookie: when ours is gone and the cart still knows the group, the cart wins.
  if (!RE_GRP.test(grp || '') && !forced && /^(holdout|exposed-[A-H])$/.test(D.cartGroup || '')) {
    grp = D.cartGroup === 'holdout' ? 'holdout' : 'exposed.' + D.cartGroup.slice(-1);
    cookie('af_pg', grp, 90);
  }
  var qArm = (location.search.match(/[?&]af(?:arm|variant)=([A-H])\b/) || [])[1];
  // a review link opens any saved arm, paused or out of its dates, so an arm is checked before it gets a share
  if (forced && qArm && !armById(qArm)) ALL.forEach(function (a) { if (a.id === qArm) ARMS.push(a); });
  if (forced) {
    grp = 'exposed.' + (qArm && armById(qArm) ? qArm : ARMS[0].id);
  } else if (!RE_GRP.test(grp || '')) {
    grp = rand() < holdout ? 'holdout' : 'exposed.' + weighted();
    cookie('af_pg', grp, 90);
    fresh = true;
  } else if (grp !== 'holdout' && !armById(grp.slice(-1))) {
    // the arm this visitor was in has been switched off: a new arm, but never out of (or into) the holdout
    grp = 'exposed.' + weighted();
    cookie('af_pg', grp, 90);
  }
  // the visitor's own group stays in its cookie; the campaign only overrides it while it lasts
  if (campArm) { if (!armById(campArm.id)) ARMS.push(campArm); grp = 'email.' + campArm.id; }
  var group = campArm ? 'email' : grp === 'holdout' ? 'holdout' : 'exposed';
  var variant = group === 'holdout' ? null : grp.slice(-1);
  var ARM = armById(variant) || ARMS[0];
  var cartValue = group === 'holdout' ? 'holdout' : group + '-' + variant;

  // ---- the game and the media for this arm. ?afgame= and ?afmedia= preview any of them.
  function pick(q, allowed, fallback) {
    var m = location.search.match(new RegExp('[?&]' + q + '=(\\w+)'));
    if (m && allowed.indexOf(m[1]) >= 0) return m[1];
    return allowed.indexOf(fallback) >= 0 ? fallback : allowed[0];
  }
  // the Halloween email shows three pumpkins, so its visitors land on the pumpkins
  var game = campArm ? 'pumpkins' : pick('afgame', GAMES, ARM.game);
  var media = pick('afmedia', ['photo', 'video'], ARM.media);
  // per arm: how it shows on a phone (full screen, picture below, bottom sheet), overriding the shop-wide layout
  if (/^(bg|full|sheet)$/.test(ARM.layout || '')) root.dataset.layout = ARM.layout;
  var phoneStep = ARM.phone !== false && ARM.phone !== 'false';
  var delay = num(ARM.delay, 2, 60, 5) * 1000;
  var halloween = ARM.theme === 'halloween' || game === 'pumpkins';
  if (halloween) { root.dataset.theme = 'halloween'; pill.dataset.theme = 'halloween'; }

  // ---- the prize (23 Oct, owner: "cost no more than now, relate to what they buy or have in the cart").
  // percent = the 10 % code; finish = tape + gloves, coat = pad + cloth, both free with a kit and costing
  // us €1,33 against the ~€8 a 10 % code gives away on a kit. The arm's reward says which:
  //   match  : the set that fits what they told us (quiz) or what the cart lacks
  //   treats : a weighted draw, Halloween's trick or treat
  // The browser only PROPOSES: popup-claim.js gives what the saved arm allows, whatever is sent.
  var PRIZES = ['percent', 'finish', 'coat'];
  var REWARD = ARM.reward || { type: 'percent' };
  var KIT = /^afterfade-(complete|double)-kit$/;
  var FINISH = /^(q1-premium-masking-tape|afterfade-nitrile-grip-gloves)$/;
  var COAT = /^(afterfade-applicator-pad|afterfade-microfibre-cloth)$/;
  var CART = null, answer = null;
  // the new products a quiz answer points to (23 Oct): the done screen links to the one that fits
  var NEWP = { shower: ['Claro-Tech+', 'afterfade-clarotech-shower-glass-coating'], fog: ['Fog-Tech+', 'afterfade-anti-fog-kit'], fabric: ['Tex-Tech+', 'afterfade-tex-tech-fabric-coating-set'] };
  function cartHas(re) { return !!(CART && CART.items && CART.items.some(function (i) { return re.test(i.handle); })); }
  function treats() {
    var t = REWARD.treats || {};
    return PRIZES.filter(function (p) { return num(t[p], 0, 100, 0) > 0; });
  }
  function choosePrize() {
    var t = REWARD.type;
    if (t === 'finish' || t === 'coat') return t;
    if (t === 'match') {
      // big surfaces want a second pad and a cloth; frames want the edges taped and the hands clean
      if (answer === 'garage' || answer === 'garden') return 'coat';
      if (answer === 'frames' || answer === 'other') return 'finish';
      if (NEWP[answer]) return 'percent';
      if (cartHas(FINISH) && !cartHas(COAT)) return 'coat';
      if (cartHas(COAT) && !cartHas(FINISH)) return 'finish';
      return 'coat';   // worth €11,90 to the visitor against tape + gloves' €6,95, for the same €1,32
    }
    if (t === 'treats') {
      var on = treats();
      if (!on.length) return 'percent';
      // the same treat on every reopen: closing and coming back is not a re-roll
      if (store.pz && on.indexOf(store.pz) >= 0) return store.pz;
      var w = REWARD.treats, total = on.reduce(function (s, p) { return s + num(w[p], 0, 100, 0); }, 0), r = rand() * total;
      for (var i = 0; i < on.length; i++) { r -= num(w[on[i]], 0, 100, 0); if (r < 0) break; }
      store.pz = on[Math.min(i, on.length - 1)]; save();
      return store.pz;
    }
    return 'percent';
  }
  var prize = choosePrize();
  if (forced) prize = pick('afprize', PRIZES, prize);

  // The cart attribute rides along to the order. Only written when the cart does not already say it.
  if (D.cartGroup !== cartValue && !forced) {
    fetch(D.cartUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { af_popup_group: cartValue } }), credentials: 'same-origin' }).catch(function () {});
  }

  // ---- events: counts only. No id, no cookie value, no address leaves the browser or is stored
  // (api/popup-event.js), the same as the kit builder's click counts (af-kit-builder, builder-event.js),
  // which have never waited for a cookie choice. They waited at first here, and on 23 Oct the live site
  // turned out to show no consent banner at all, so nobody could ever consent and the test arms had no
  // numbers. COUNT_WITHOUT_CONSENT = false puts the wait back (it then needs a banner on the shop).
  var COUNT_WITHOUT_CONSENT = true;
  function consented() {
    if (COUNT_WITHOUT_CONSENT) return true;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function track(e) {
    if (forced || !consented()) return false;
    var seen = group !== 'holdout';
    var body = JSON.stringify({ e: e, v: variant, g: group, gm: seen ? game : null, md: seen ? media : null, pz: seen ? prize : null, l: D.lang, m: D.market, d: mobile ? 'm' : 'd' });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(D.api + '/api/popup-event', body)) return true;
    } catch (err) {}
    fetch(D.api + '/api/popup-event', { method: 'POST', body: body, keepalive: true, mode: 'cors' }).catch(function () {});
    return true;
  }
  // The visitor counted once: the denominator for orders per visitor. Consent can arrive later than the
  // assignment, so the count waits for it instead of being lost.
  if (fresh) { store.counted = 0; save(); }
  function countVisitor() { if (!store.counted && track('assign')) { store.counted = 1; save(); } }
  countVisitor();
  document.addEventListener('visitorConsentCollected', countVisitor);

  // ---- the gift in the cart. A gift code is "buy a kit, get the set free", so the set goes in only next to
  // a kit: on its own it would be charged. Claimed without a kit, it waits here and joins the cart the
  // moment a kit does, on any page. Once it has been in a cart that is then checked out (a new cart token),
  // it is spent and never added again. A kit taken out takes the gift lines we added with it.
  var giftBusy = false;
  function cartJs() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function cartPost(path, body) {
    return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function giftLines(cart, ids) { return (cart.items || []).filter(function (i) { return ids.indexOf(Number(i.variant_id)) >= 0; }); }
  function applyCode(code) {
    // /cart/update.js takes a discount since 2024; the /discount/ link is the long-standing fallback
    return cartPost('/cart/update.js', { discount: code }).catch(function () { return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }); });
  }
  function syncGift() {
    var g = store.gift;
    if (!g || !g.ids || giftBusy) return Promise.resolve(null);
    giftBusy = true;
    return cartJs().then(function (cart) {
      CART = cart;
      var kit = cartHas(KIT), have = giftLines(cart, g.ids);
      if (g.token && g.token !== cart.token) { delete store.gift; save(); return cart; }
      if (kit && !g.token) {
        var missing = g.ids.filter(function (id) { return !have.some(function (l) { return Number(l.variant_id) === id; }); });
        return (missing.length ? cartPost('/cart/add.js', { items: missing.map(function (id) { return { id: id, quantity: 1 }; }) }) : Promise.resolve())
          .then(function () { return applyCode(g.code); })
          .then(function () { g.token = cart.token; save(); return cartJs(); })
          .then(function (c) { CART = c; document.dispatchEvent(new CustomEvent('cart:update', { detail: {} })); return c; });
      }
      if (!kit && g.token === cart.token && have.length) {
        var upd = {};
        have.forEach(function (l) { if (l.quantity === 1) upd[l.key] = 0; });
        g.token = null; save();
        if (!Object.keys(upd).length) return cart;
        return cartPost('/cart/update.js', { updates: upd }).then(function (c) { CART = c; document.dispatchEvent(new CustomEvent('cart:update', { detail: {} })); return c; });
      }
      return cart;
    }).catch(function () { return null; }).then(function (c) { giftBusy = false; return c; });
  }
  // The theme fires ajaxProduct:added after every add to cart from the product form and quick buy. The kit
  // builder does not: it writes the cart with one /cart/update.js call and redraws the drawer itself, so a
  // kit built there never pulled the gift in, and its winners checked out from the drawer without the set
  // (2 of the first 5 who missed it, 25 to 28 Oct). Any redraw of the drawer's cart is the signal as well.
  // Only a change in the item count counts, so the recommendations loading into the drawer cost no /cart.js
  // call, and syncGift's own redraw finds nothing left to do: this cannot loop.
  var giftHooked = false, drawerTimer = null;
  function hookGift() {
    if (giftHooked) return;
    giftHooked = true;
    document.addEventListener('ajaxProduct:added', function () { setTimeout(syncGift, 300); });
    var drawer = document.getElementById('drawer-cart');
    if (!drawer || !window.MutationObserver) return;
    var countNow = function () { var c = drawer.querySelector('[data-afc-count]'); return c ? c.textContent.trim() : ''; };
    var seen = countNow();
    new MutationObserver(function () {
      var n = countNow();
      if (n === seen) return;
      seen = n;
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(syncGift, 400);
    }).observe(drawer, { childList: true, subtree: true, characterData: true });
  }
  if (store.gift) {
    syncGift();
    hookGift();
  }

  // ---- add to cart, for every group, the holdout included: orders per visitor need weeks to separate the
  // popup from the holdout, adds to cart come about ten times as often (owner 24 Oct: "is it deterring
  // people?"). The theme fires ajaxProduct:added after every add (product form and quick buy).
  document.addEventListener('ajaxProduct:added', function () { track('atc'); });

  // ---- 2. should it show at all
  if (group === 'holdout') return;
  if (noArm && !forced) return;
  // a campaign click opens even for someone who claimed before: the claim then answers "already" with
  // their own code, which is what "one treat per person" means
  if (!campOpen && (store.claimed || cookie('af_pc'))) return;
  // Someone who arrived from one of our emails is already on the list: Klaviyo's onsite script
  // identifies them in __kla_id. Telling a subscriber to sign up for 10 % is how codes leak to buyers.
  try {
    var kla = cookie('__kla_id');
    if (kla && !forced && !campArm) {
      var k = JSON.parse(atob(kla));
      if (k && (k.$exchange_id || k.$email)) return;
    }
  } catch (e) {}

  // page views on this browser, for an arm that never opens on someone's very first page (softer than 5 s in)
  store.pv = (store.pv || 0) + 1; save();
  var autoOk = forced || !store.seen || now - store.seen > 7 * DAY;
  if (!forced && ARM.trigger === 'pages2' && store.pv < 2) autoOk = false;
  var pillOk = !!store.seen && !(store.pillOff && now - store.pillOff < 7 * DAY);
  root.dataset.game = game;
  root.querySelectorAll('.afp__game').forEach(function (g) { if (g.dataset.game !== game) g.parentNode.removeChild(g); });
  ['[data-afp-game-h]', '[data-afp-game-p]'].forEach(function (sel) {
    var el = root.querySelector(sel);
    el.textContent = dec(halloween && el.dataset.halloween ? el.dataset.halloween : el.dataset[game]);
  });
  if (halloween && S.hwPill) pill.querySelector('[data-afp-pill] span').textContent = S.hwPill;

  // ---- the prize on screen. Every place a game shows what is won carries data-pz (big, sub, title,
  // note), filled from the strings for this prize. The cart is read once, so a visitor who already has
  // a kit reads "with the kit in your cart", and a "match" arm can pick the set the cart lacks.
  function gname() { return S['pz_' + prize] || ''; }
  // "[gift] zdarma k vašemu Kitu?": a sentence can start with the set's name, which is lower case
  function fill(t) { var x = String(t || '').replace('[gift]', gname()); return x.charAt(0).toUpperCase() + x.slice(1); }
  function pzText(part) {
    if (prize === 'percent') return S['pc_' + part] || '';
    if (part === 'big') return S.pzFree;
    if (part === 'sub') return gname();
    if (part === 'title') return S['pz_' + prize + '_title'];
    if (part === 'note') return cartHas(KIT) ? S.pzNoteKit : S.pzNote;
    return '';
  }
  var paintWheel = function () {}, isGift = prize !== 'percent';
  function setPrize(p) {
    if (revealed && p !== prize) return;   // never change a prize the visitor has already seen
    prize = p; isGift = p !== 'percent';
    root.dataset.prize = p;
    [].forEach.call(root.querySelectorAll('[data-pz]'), function (el) { el.textContent = pzText(el.dataset.pz); });
    var cl = root.querySelector('[data-afp-claim]'); if (cl) cl.textContent = isGift ? S.pzClaim : S.pcClaim;
    var eh = root.querySelector('[data-afp-email-h]'), ep = root.querySelector('[data-afp-email-p]'), es = root.querySelector('[data-afp-email] button[type=submit]');
    if (eh) eh.textContent = isGift ? S.pzEmailH : S.pcEmailH;
    if (ep) ep.textContent = isGift ? S.pzEmailP : S.pcEmailP;
    if (es) es.textContent = isGift ? S.pzSubmit : S.pcSubmit;
    var pp = root.querySelector('[data-afp-phone-p]'); if (pp) pp.textContent = isGift ? S.pzPhoneP : S.pcPhoneP;
    if (game === 'yesno') {
      var h = root.querySelector('[data-afp-game-h]'), y = root.querySelector('[data-afp-yes]');
      if (isGift) { h.textContent = fill(S.pzAsk); y.textContent = S.pzYes; }
    }
    paintWheel();
  }

  // ---- 3. other overlays
  var lastOverlay = 0;
  function visible(el) { return !!el && !el.hidden && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function overlayOpen() {
    // the theme locks the page (body.overflow-hidden) under its menu, cart, search and quick-buy drawers
    if (document.body.classList.contains('overflow-hidden')) return true;
    var t = document.getElementById('af-locale-toast');
    if (t && !t.hidden && t.classList.contains('is-in')) return true;
    var open = document.querySelectorAll('.drawer.is-open, drawer-cart[open], drawer-menu[open], .drawer[open], .af-vs__modal:not([hidden]), [id^="alia-root"] [role="dialog"]');
    for (var i = 0; i < open.length; i++) if (visible(open[i])) return true;
    var modals = document.querySelectorAll('[aria-modal="true"]');
    for (var j = 0; j < modals.length; j++) if (!root.contains(modals[j]) && visible(modals[j])) return true;
    return false;
  }
  // The pill never sits on top of a menu, the cart or any other layer (owner, 23 Oct): it steps aside the
  // moment one opens and comes back when it closes. Watched on the elements that change, not polled.
  function syncPill() { var o = overlayOpen(); pill.classList.toggle('is-covered', o); if (o) lastOverlay = Date.now(); }
  if (window.MutationObserver) {
    var mo = new MutationObserver(syncPill);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    [].forEach.call(document.querySelectorAll('.drawer, #af-locale-toast, .af-vs__modal'), function (el) {
      mo.observe(el, { attributes: true, attributeFilter: ['class', 'hidden', 'open'] });
    });
  }
  setInterval(syncPill, 1000);

  // ---- the dialog
  var opened = false, isOpen = false, lastFocus = null, step = 'game', state = null, token = null, t0 = 0;
  var img = root.querySelector('.afp__photo'), kit = root.querySelector('.afp__kit');

  function show(name) {
    step = name;
    root.querySelectorAll('.afp__step').forEach(function (s) {
      var on = s.dataset.step === name;
      s.hidden = !on;
      s.classList.toggle('is-on', on);
    });
    dialog.setAttribute('aria-labelledby', 'afp-h-' + name);
    root.dataset.step = name;
    var here = '.afp__step[data-step="' + name + '"] ';
    var f = root.querySelector(here + 'input:not([tabindex="-1"]), ' + here + '.afp__btn:not([hidden]), ' + here + '[data-afp-pick], ' + here + '[data-afp-gift], ' + here + '[data-afp-reveal]');
    // focus always lands inside the dialog, or Tab walks the page behind it. On a phone the dialog itself
    // takes it: an input would pull the keyboard over the step, and a focused button shows a ring nobody
    // asked for (23 Oct screenshots)
    var target = f && !mobile ? f : dialog;
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }, 60);
  }

  var hideTimer = null;
  function open(how) {
    if (isOpen) return;
    clearTimeout(hideTimer);
    // the stylesheet loads off the critical path; opening before it applies shows raw markup and sizes
    // the foil at zero
    if (getComputedStyle(root).position !== 'fixed') { setTimeout(function () { open(how); }, 120); return; }
    isOpen = true;
    if (img && !img.src) img.src = ARM.photo || D.img;
    if (kit && !kit.src) kit.src = kit.dataset.src;
    startVideo();
    lastFocus = document.activeElement;
    root.hidden = false;
    pill.hidden = true;
    document.documentElement.classList.add('afp-lock');
    requestAnimationFrame(function () { root.classList.add('is-in'); });
    if (!opened) { opened = true; t0 = Date.now(); store.seen = Date.now(); save(); requestAnimationFrame(setupFoil); }
    show(state ? 'done' : step);
    track(how === 'pill' ? 'pill' : 'view');
  }

  // A video in the media panel instead of the photo: muted, looped, inline, fetched only when the popup
  // opens. Not for reduced motion or data saver: they keep the still photo, which is also the poster.
  var video = root.querySelector('.afp__video');
  function startVideo() {
    if (media !== 'video' || !video) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saver = navigator.connection && navigator.connection.saveData;
    if (still || saver) return;
    if (!video.src) {
      // a phone gets the portrait clip, a desktop the landscape one: each arm can pick both. The bottom sheet
      // is the exception: its picture is a wide strip, where a portrait clip shows only a slice (owner 24 Oct:
      // "the picture is cut off"), so it plays the landscape clip on a phone too
      var tall = mobile && root.dataset.layout !== 'sheet';
      video.poster = (tall ? ARM.poster_m || POSTER_M : ARM.poster_d || POSTER_D);
      video.src = tall ? ARM.video_m || VIDEO_M : ARM.video_d || VIDEO_D;
      video.hidden = false;
      root.classList.add('has-video');
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-in');
    document.documentElement.classList.remove('afp-lock');
    hideTimer = setTimeout(function () { root.hidden = true; }, 220);
    if (video && !video.paused) video.pause();
    if (step !== 'done') track('close');
    if (!state && !(store.pillOff && Date.now() - store.pillOff < 7 * DAY)) pill.hidden = false;
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-afp-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // keep Tab inside the dialog while it is open
    var f = [].filter.call(dialog.querySelectorAll('button, input, select, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.tabIndex !== -1 && el.getClientRects().length;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  pill.querySelector('[data-afp-pill]').addEventListener('click', function () { open('pill'); });
  pill.querySelector('[data-afp-pill-x]').addEventListener('click', function () {
    pill.hidden = true; store.pillOff = Date.now(); save();
  });

  // ---- scratch card. Canvas foil over the prize; the pointer erases it. Revealed at 55 % or by the
  // button (keyboard, reduced motion, or someone who just wants to see it).
  var foil = root.querySelector('[data-afp-foil]');
  var card = root.querySelector('[data-afp-card]');
  var revealBtn = root.querySelector('[data-afp-reveal]');
  var claimBtn = root.querySelector('[data-afp-claim]');
  var ctx = null, revealed = false, drawing = false, last = null, moves = 0;

  function setupFoil() {
    if (!foil || revealed || moves > 0 || drawing) return;
    if (!card.offsetWidth) { setTimeout(setupFoil, 100); return; }
    // layout size, not getBoundingClientRect: the dialog is still scaling in when this runs
    var r = { width: card.offsetWidth, height: card.offsetHeight };
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    foil.width = Math.round(r.width * dpr);
    foil.height = Math.round(r.height * dpr);
    ctx = foil.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, '#c9a46a'); g.addColorStop(0.45, '#f1dcb2'); g.addColorStop(0.55, '#e3c9a6'); g.addColorStop(1, '#b8915a');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, r.width, r.height);
    // a little texture so it reads as foil, not a flat button
    ctx.globalAlpha = 0.12;
    for (var i = 0; i < 220; i++) { ctx.fillStyle = i % 2 ? '#fff' : '#7a5a2e'; ctx.fillRect(rand() * r.width, rand() * r.height, 1.5, 1.5); }
    ctx.globalAlpha = 1;
    ctx.fillStyle = '#2b1d3f';
    ctx.font = '700 15px Montserrat, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var label = dec(foil.dataset.label);
    if (ctx.letterSpacing !== undefined) ctx.letterSpacing = '3px';
    ctx.fillText(label, r.width / 2, r.height / 2);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(34, r.height / 3.2);
  }

  function pos(e) {
    var r = foil.getBoundingClientRect(), k = foil.offsetWidth / (r.width || 1);
    return { x: (e.clientX - r.left) * k, y: (e.clientY - r.top) * k };
  }
  function scratched() {
    var w = foil.width, h = foil.height, step = 12, clear = 0, n = 0;
    var data = ctx.getImageData(0, 0, w, h).data;
    for (var y = step / 2; y < h; y += step) for (var x = step / 2; x < w; x += step) { n++; if (data[(Math.floor(y) * w + Math.floor(x)) * 4 + 3] < 40) clear++; }
    return n ? clear / n : 0;
  }
  function reveal(byHand) {
    if (revealed) return;
    revealed = true;
    if (card) card.classList.add('is-revealed');
    if (revealBtn) revealBtn.hidden = true;
    // the spent Spin / Drop button gives way to Claim
    [].forEach.call(root.querySelectorAll('.afp__play'), function (p) { p.hidden = true; });
    root.classList.add('is-won');
    claimBtn.hidden = false;
    try { if (byHand && navigator.vibrate) navigator.vibrate(25); } catch (e) {}
    track('scratch');   // 'scratch' = the game was played, whichever game it was
    setTimeout(function () { claimBtn.focus({ preventScroll: true }); }, 350);
  }
  if (foil) {
    foil.addEventListener('pointerdown', function (e) {
      if (revealed || !ctx) return;
      drawing = true; moves++; last = pos(e);
      try { foil.setPointerCapture(e.pointerId); } catch (err) {}
      ctx.beginPath(); ctx.arc(last.x, last.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill();
      card.classList.add('is-scratching');
    });
    foil.addEventListener('pointermove', function (e) {
      if (!drawing || revealed) return;
      var p = pos(e);
      ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      last = p;
      if (++moves % 6 === 0 && scratched() >= 0.55) reveal(true);
    });
    var stop = function () { if (drawing && !revealed && scratched() >= 0.55) reveal(true); drawing = false; };
    foil.addEventListener('pointerup', stop);
    foil.addEventListener('pointercancel', stop);
  }
  // a rotated phone or a resized window before the first stroke: repaint the foil at the new size
  if (window.ResizeObserver && card) new ResizeObserver(function () { if (ctx && !moves && !drawing && !revealed && Math.round(card.offsetWidth * Math.min(2, window.devicePixelRatio || 1)) !== foil.width) setupFoil(); }).observe(card);
  if (revealBtn) revealBtn.addEventListener('click', function () { reveal(false); });

  // ---- pick a card: three face down, the one tapped turns over, the other two step back
  var cards = root.querySelector('.afp__cards');
  if (cards) cards.addEventListener('click', function (e) {
    var b = e.target.closest('[data-afp-pick]');
    if (!b || revealed || cards.classList.contains('is-done')) return;
    b.classList.add('is-picked');
    cards.classList.add('is-done');
    [].forEach.call(cards.querySelectorAll('[data-afp-pick]'), function (x) { x.disabled = x !== b; });
    setTimeout(function () { reveal(true); }, 650);
  });

  // ---- the gift box: a wiggle, the lid comes off, the prize rises out of it
  var gift = root.querySelector('[data-afp-gift]');
  if (gift) gift.addEventListener('click', function () {
    if (revealed || gift.classList.contains('is-open')) return;
    gift.classList.add('is-open');
    setTimeout(function () { reveal(true); }, 900);
  });
  claimBtn.addEventListener('click', function () { show('email'); });

  // ---- mystery box: three boxes, the one tapped opens, the other two step back
  var boxes = root.querySelector('.afp__boxes');
  if (boxes) boxes.addEventListener('click', function (e) {
    var b = e.target.closest('[data-afp-box]');
    if (!b || revealed || boxes.classList.contains('is-done')) return;
    boxes.classList.add('is-done');
    b.classList.add('is-open', 'is-picked');
    [].forEach.call(boxes.querySelectorAll('[data-afp-box]'), function (x) { x.disabled = x !== b; });
    setTimeout(function () { reveal(true); }, 900);
  });

  // ---- spin to win. Eight segments, every prize segment the same 10 %, the rest stars: it can only land
  // on what we give (Alia's own wheel "always gives same reward", but shows other prizes on its rim).
  var wheel = root.querySelector('[data-afp-wheel]');
  if (wheel) {
    var N = 8, rim = [];
    var esc = function (t) { return String(t || '').replace(/[<&]/g, ''); };
    paintWheel = function () {
      if (wheel.classList.contains('is-spinning')) return;
      // prize segments carry what this arm can give: one prize on every one of them, or for a
      // trick-or-treat arm each treat in turn. The other segments are stars, never a prize we do not give.
      var kinds = REWARD.type === 'treats' && treats().length > 1 ? treats() : [prize], segs = '';
      rim = [];
      for (var i = 0; i < N; i++) {
        var kind = i % 2 ? null : kinds[(i / 2) % kinds.length];
        rim.push(kind);
        var a0 = (i / N) * 2 * Math.PI - Math.PI / 2 - Math.PI / N, a1 = a0 + 2 * Math.PI / N;
        var x0 = 96 * Math.cos(a0), y0 = 96 * Math.sin(a0), x1 = 96 * Math.cos(a1), y1 = 96 * Math.sin(a1);
        var mid = (a0 + a1) / 2, tx = 62 * Math.cos(mid), ty = 62 * Math.sin(mid), deg = mid * 180 / Math.PI + 90;
        segs += '<path d="M0 0L' + x0.toFixed(2) + ' ' + y0.toFixed(2) + 'A96 96 0 0 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + 'Z" class="afp__seg afp__seg--' + (i % 2 ? 'b' : 'a') + '"/>';
        var tr = ' transform="rotate(' + deg.toFixed(1) + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ')"';
        if (!kind) segs += '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '"' + tr + ' class="afp__seg-t afp__seg-t--b">★</text>';
        else if (kind === 'percent') segs += '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '"' + tr + ' class="afp__seg-t afp__seg-t--a">' + esc(S.pc_big) + '</text>';
        else {
          // a gift's name is too long to run across a segment ("σφουγγαράκι + πανί"), so it runs along the
          // radius, FREE above it, turned on the left half of the wheel so it never reads upside down
          var rd = mid * 180 / Math.PI, gx = 58 * Math.cos(mid), gy = 58 * Math.sin(mid);
          if (Math.cos(mid) < -0.01) rd += 180;
          var gr = ' transform="rotate(' + rd.toFixed(1) + ' ' + gx.toFixed(1) + ' ' + gy.toFixed(1) + ')"';
          segs += '<text x="' + gx.toFixed(1) + '" y="' + gy.toFixed(1) + '"' + gr + ' class="afp__seg-t afp__seg-t--a afp__seg-t--gift"><tspan x="' + gx.toFixed(1) + '" dy="-6">' + esc(S.pzFree) + '</tspan><tspan x="' + gx.toFixed(1) + '" dy="12" class="afp__seg-s">' + esc(S['pz_' + kind]) + '</tspan></text>';
        }
      }
      wheel.innerHTML = '<circle r="99" class="afp__wheel-rim"/>' + segs;
    };
    paintWheel();
    root.querySelector('[data-afp-spin]').addEventListener('click', function () {
      if (revealed || wheel.classList.contains('is-spinning')) return;
      this.disabled = true;
      wheel.classList.add('is-spinning');
      // land a segment carrying THIS visitor's prize under the pin at the top, after five full turns
      var hits = []; rim.forEach(function (kd, j) { if (kd === prize) hits.push(j); });
      var k = hits.length ? hits[Math.floor(rand() * hits.length)] : 0, turn = 360 * 5 + (360 - k * (360 / N)) + (rand() - .5) * 18;
      wheel.style.transform = 'rotate(' + turn + 'deg)';
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(function () { reveal(true); }, still ? 50 : 4300);
    });
  }

  // ---- plinko: a ball through seven rows of pegs into one of five buckets, all of them 10 %
  var plinko = root.querySelector('[data-afp-plinko]');
  if (plinko) {
    var ROWS = 7, COLS = 5, W = 300, top = 26, gap = 26, pegs = '', buckets = '';
    for (var r = 0; r < ROWS; r++) for (var c = 0; c <= r + 2; c++) pegs += '<circle cx="' + (W / 2 + (c - (r + 2) / 2) * 30) + '" cy="' + (top + r * gap) + '" r="3.2" class="afp__peg"/>';
    for (var b = 0; b < COLS; b++) {
      var bx = 20 + b * 52;
      // a question mark until the ball lands: the prize is the surprise (owner, 23 Oct)
      buckets += '<rect x="' + bx + '" y="214" width="48" height="40" rx="8" class="afp__bucket" data-b="' + b + '"/><text x="' + (bx + 24) + '" y="240" class="afp__bucket-t" data-t="' + b + '">?</text>';
    }
    plinko.innerHTML = pegs + buckets + '<circle class="afp__ball" r="8" cx="150" cy="6"/>';
    var ball = plinko.querySelector('.afp__ball');
    root.querySelector('[data-afp-drop]').addEventListener('click', function () {
      if (revealed || plinko.classList.contains('is-dropping')) return;
      this.disabled = true;
      plinko.classList.add('is-dropping');
      // a path of left/right bounces, one per row, then into the bucket under it
      var pts = [[150, 6]], x = 150;
      for (var r = 0; r < ROWS; r++) { x += (rand() < .5 ? -15 : 15); x = Math.max(44, Math.min(256, x)); pts.push([x, top + r * gap - 10]); }
      var bi = Math.max(0, Math.min(COLS - 1, Math.round((x - 44) / 52)));
      pts.push([44 + bi * 52, 232]);
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches, seg = still ? 1 : 260, t0p = null;
      function frame(t) {
        if (t0p === null) t0p = t;
        var e = (t - t0p) / seg, i = Math.min(pts.length - 2, Math.floor(e)), f = Math.min(1, e - i);
        var p0 = pts[i], p1 = pts[i + 1], hop = Math.sin(f * Math.PI) * 6;
        ball.setAttribute('cx', (p0[0] + (p1[0] - p0[0]) * f).toFixed(1));
        ball.setAttribute('cy', (p0[1] + (p1[1] - p0[1]) * f * f - hop).toFixed(1));
        if (e < pts.length - 1) return requestAnimationFrame(frame);
        var hit = plinko.querySelector('.afp__bucket[data-b="' + bi + '"]');
        if (hit) hit.classList.add('is-hit');
        var ht = plinko.querySelector('.afp__bucket-t[data-t="' + bi + '"]');
        if (ht) { ht.textContent = prize === 'percent' ? S.pc_big : S.pzFree; ht.classList.add('is-hit'); }
        // the ball drops into the bucket and out of the way, so the 10 % it lands on is readable
        ball.classList.add('is-in');
        setTimeout(function () { reveal(true); }, still ? 50 : 350);
      }
      requestAnimationFrame(frame);
    });
  }

  // ---- mini quiz: what do you want to restore? The answer is zero-party data on the Klaviyo profile,
  // and on a "match" arm it picks the gift.
  var won = root.querySelector('[data-afp-won]');
  var quiz = root.querySelector('.afp__quiz');
  if (quiz) quiz.addEventListener('click', function (e) {
    var b = e.target.closest('[data-afp-answer]');
    if (!b || revealed) return;
    answer = b.dataset.afpAnswer;
    setPrize(choosePrize());
    b.classList.add('is-picked');
    quiz.classList.add('is-done');
    setTimeout(function () { quiz.hidden = true; won.hidden = false; reveal(true); }, 350);
  });

  // ---- microcommitment: "want 10 % off?" Yes goes straight to the email; No closes it for good (7 days).
  var yes = root.querySelector('[data-afp-yes]');
  if (yes) {
    yes.addEventListener('click', function () { revealed = true; root.classList.add('is-won'); track('scratch'); show('email'); });
    root.querySelector('[data-afp-no]').addEventListener('click', function () { track('decline'); store.pillOff = Date.now(); save(); close(); pill.hidden = true; });
  }

  // ---- email
  var emailForm = root.querySelector('[data-afp-email]');
  var emailInput = emailForm.querySelector('input[type=email]');
  var suggest = emailForm.querySelector('[data-afp-suggest]');
  var email = '', memberCode = '';

  // The typos that cost a welcome code: the address bounces and the visitor thinks we never sent it.
  var DOMAINS = { 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmail.co': 'gmail.com',
    'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.be': 'gmail.com', 'gmail.nl': 'gmail.com', 'gmaill.com': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmal.com': 'hotmail.com',
    'hotmail.b': 'hotmail.be', 'hotmial.be': 'hotmail.be', 'outlook.con': 'outlook.com', 'outlok.com': 'outlook.com',
    'yahoo.con': 'yahoo.com', 'yaho.com': 'yahoo.com', 'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com',
    'telenet.b': 'telenet.be', 'telenet.ne': 'telenet.be', 'skynet.b': 'skynet.be', 'live.b': 'live.be' };
  function typo(v) {
    var m = v.match(/^([^@\s]+)@([^@\s]+)$/);
    return m && DOMAINS[m[2].toLowerCase()] ? m[1] + '@' + DOMAINS[m[2].toLowerCase()] : null;
  }
  emailInput.addEventListener('blur', function () {
    var s = typo(emailInput.value.trim());
    suggest.hidden = !s;
    if (s) suggest.querySelector('button').textContent = s;
  });
  suggest.querySelector('button').addEventListener('click', function () {
    emailInput.value = this.textContent; suggest.hidden = true; emailInput.focus();
  });

  function err(form, msg) {
    var p = form.querySelector('[data-afp-err]');
    p.textContent = msg || '';
    p.hidden = !msg;
  }
  function busy(form, on) {
    var b = form.querySelector('button[type=submit]');
    if (on) { b.dataset.label = b.textContent; b.textContent = S.sending || '...'; b.disabled = true; form.setAttribute('aria-busy', 'true'); }
    else { if (b.dataset.label) b.textContent = b.dataset.label; b.disabled = false; form.removeAttribute('aria-busy'); }
  }
  function post(body) {
    return fetch(D.api + '/api/popup-claim', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), mode: 'cors' })
      .then(function (r) { return r.json().catch(function () { return { ok: false, reason: 'later' }; }); })
      .catch(function () { return { ok: false, reason: 'later' }; });
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err(emailForm, S.errEmail); emailInput.focus(); return; }
    err(emailForm, '');
    busy(emailForm, true);
    post({ step: 'email', email: v, lang: D.lang, market: D.market, variant: variant, group: group, game: game, answer: answer, prize: prize,
      hp: emailForm.querySelector('[name=company]').value, ms: Date.now() - t0 })
      .then(function (r) {
        busy(emailForm, false);
        if (!r || !r.ok) { err(emailForm, r && r.reason === 'email' ? S.errEmail : S.errBusy); return; }
        email = v.toLowerCase(); state = r.state || 'sent'; token = r.token; memberCode = r.code || '';
        if (state === 'sent' && memberCode) state = 'screen';
        // a gift arm: the code and the set come back, and the set goes into the cart (syncGift)
        if (r.gift && r.code && r.gift.length) {
          state = 'gift'; prize = r.prize || prize;
          store.gift = { ids: r.gift.map(Number), code: r.code, prize: prize, token: null };
          hookGift();
        }
        store.claimed = Date.now(); save();
        cookie('af_pc', '1', 365);
        track('email');
        if (phoneStep && state !== 'customer') { fillDial(); show('phone'); } else done();
      });
  });

  // ---- phone (WhatsApp, optional)
  var phoneForm = root.querySelector('[data-afp-phone]');
  // Every country we sell to (75, the Shopify markets on 23 Oct 2026): our main markets first, then A to Z.
  var DIAL = [['BE', '32'], ['NL', '31'], ['LU', '352'], ['FR', '33'], ['DE', '49'], ['AT', '43'], ['ES', '34'], ['PT', '351'], ['IT', '39'], ['AD', '376'],
    ['AE', '971'], ['AL', '355'], ['AO', '244'], ['AU', '61'], ['BA', '387'], ['BG', '359'], ['BR', '55'], ['CA', '1'], ['CH', '41'], ['CN', '86'],
    ['CV', '238'], ['CY', '357'], ['CZ', '420'], ['DK', '45'], ['DO', '1'], ['EE', '372'], ['EG', '20'], ['FI', '358'], ['GB', '44'], ['GE', '995'],
    ['GR', '30'], ['HK', '852'], ['HR', '385'], ['HU', '36'], ['ID', '62'], ['IE', '353'], ['IL', '972'], ['IN', '91'], ['IS', '354'], ['JP', '81'],
    ['KE', '254'], ['KR', '82'], ['LI', '423'], ['LK', '94'], ['LT', '370'], ['LV', '371'], ['MA', '212'], ['MC', '377'], ['ME', '382'], ['MK', '389'],
    ['MT', '356'], ['MU', '230'], ['MV', '960'], ['MX', '52'], ['MY', '60'], ['NO', '47'], ['NZ', '64'], ['PF', '689'], ['PL', '48'], ['RO', '40'],
    ['RS', '381'], ['SA', '966'], ['SE', '46'], ['SG', '65'], ['SI', '386'], ['SK', '421'], ['SM', '378'], ['TH', '66'], ['TN', '216'], ['TR', '90'],
    ['TZ', '255'], ['UA', '380'], ['US', '1'], ['VN', '84'], ['ZA', '27']];
  function fillDial() {
    var sel = phoneForm.querySelector('[data-afp-dial]');
    if (sel.options.length) return;
    var mine = DIAL.some(function (d) { return d[0] === D.market; }) ? D.market : 'BE';
    DIAL.forEach(function (d) {
      var o = document.createElement('option');
      o.value = d[1]; o.textContent = d[0] + ' +' + d[1]; o.selected = d[0] === mine;
      sel.appendChild(o);
    });
  }
  phoneForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var dial = phoneForm.querySelector('[data-afp-dial]').value;
    var raw = phoneForm.querySelector('input[type=tel]').value.replace(/[\s().\/-]/g, '');
    var num = /^(\+|00)/.test(raw) ? raw.replace(/^00/, '+') : '+' + dial + raw.replace(/^0/, '');
    if (!/^\+[1-9]\d{7,14}$/.test(num)) { err(phoneForm, S.errPhone); return; }
    if (!phoneForm.querySelector('[data-afp-consent]').checked) { err(phoneForm, S.errConsent); return; }
    err(phoneForm, '');
    busy(phoneForm, true);
    post({ step: 'phone', token: token, phone: num, consent: true, lang: D.lang }).then(function (r) {
      busy(phoneForm, false);
      if (!r || !r.ok) { err(phoneForm, r && r.reason === 'phone' ? S.errPhone : S.errBusy); return; }
      track('phone');
      done();
    });
  });
  root.querySelector('[data-afp-copy]').addEventListener('click', function () {
    var b = this;
    var ok = function () { b.textContent = dec(b.dataset.copied); setTimeout(function () { b.textContent = dec(b.dataset.copy); }, 2000); };
    try { navigator.clipboard.writeText(memberCode).then(ok, function () {}); } catch (e) {}
  });
  phoneForm.querySelector('[data-afp-skip]').addEventListener('click', function () { track('skip'); done(); });

  var doneOnce = false;
  function done() {
    if (doneOnce) return;
    doneOnce = true;
    if (state === 'gift') {
      // put the set in the cart first, so the screen can say where it is
      syncGift().then(function () { paintDone(); });
      return;
    }
    paintDone();
  }
  function paintDone() {
    var h = root.querySelector('[data-afp-done-h]'), p = root.querySelector('[data-afp-done-p]');
    var go = root.querySelector('[data-afp-go]'), shop = root.querySelector('[data-afp-shop]');
    if (state === 'gift') {
      var kit = cartHas(KIT);
      h.textContent = kit ? S.pzDoneKitH : S.pzDoneH;
      p.textContent = fill(kit ? S.pzDoneKit : S.pzDone);
      go.href = kit ? D.cartPage : D.kitPage;
      go.textContent = kit ? S.pzGoCart : S.pzGoKit;
      go.hidden = false;
      shop.className = 'afp__skip';
    } else {
      h.textContent = dec(h.dataset[state] || h.dataset.sent);
      p.textContent = dec(p.dataset[state] || p.dataset.sent).replace('[email]', email);
      if (NEWP[answer]) {
        go.href = (D.root === '/' ? '' : D.root) + '/products/' + NEWP[answer][1];
        go.textContent = (S.goProduct || '[product]').replace('[product]', NEWP[answer][0]);
        go.hidden = false;
        shop.className = 'afp__skip';
      }
    }
    root.querySelector('[data-afp-done-note]').hidden = state === 'customer' || state === 'member' || state === 'screen' || state === 'gift';
    // on screen for an arm set to show it, for someone already on our list (no Welcome email will start),
    // and for a gift, as a spare in case the cart lost it
    var box = root.querySelector('[data-afp-code]');
    box.hidden = !((state === 'member' || state === 'screen' || state === 'gift') && memberCode);
    if (!box.hidden) box.querySelector('[data-afp-code-v]').textContent = memberCode;
    pill.hidden = true;
    show('done');
    track('done');
  }

  setPrize(prize);
  // a review link with &afprize= keeps the prize it asked for
  var pinned = forced && /[?&]afprize=/.test(location.search);
  cartJs().then(function (c) { CART = c; if (!revealed) setPrize(pinned ? prize : choosePrize()); }).catch(function () {});

  // ---- 4. when to open
  if (forced) { open('auto'); return; }
  if (campOpen) {
    open('auto');
    var nPick = Number((location.search.match(/[?&]afpick=([1-3])\b/) || [])[1]);
    if (nPick) setTimeout(function tap() {
      var b = root.querySelectorAll('[data-afp-box]')[nPick - 1];
      if (!isOpen) return setTimeout(tap, 200);
      if (b && !revealed) b.click();
    }, 1100);
    return;
  }
  if (!autoOk) { if (pillOk) pill.hidden = false; return; }

  var scrolled = false, timeUp = false, armed = true;
  function tryOpen() {
    if (!armed || isOpen) return;
    if (overlayOpen()) lastOverlay = Date.now();
    if (Date.now() - lastOverlay < 15000) { setTimeout(tryOpen, 1000); return; }
    armed = false;
    open('auto');
  }
  function check() { if (scrolled && timeUp) tryOpen(); }
  window.addEventListener('scroll', function onScroll() {
    if (window.scrollY > 40) { scrolled = true; window.removeEventListener('scroll', onScroll); check(); }
  }, { passive: true });
  setTimeout(function () { timeUp = true; check(); }, delay);
  // exit intent: the pointer leaves through the top of the window (desktop only, there is no pointer on a phone)
  if (exitIntent && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - now > 3000) tryOpen();
    });
  }
})();
